module.exports = __webpack_public_path__ + "static/media/template_placeholder.6f640c19.svg";